import React from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash';
import withData from '@bd/bdcore-data';
import { css } from '@bd/bdui-styles/emotion';
import { Link } from '@bd/bdcore-named-routes';

const styles = css`
  display: block;
  position: absolute;
  width: auto;
  height: 60px;
  top: 10px;
  left: 10px;
  z-index: 2;
  @media (min-width: 768px) {
    height: 90px;
    top: 20px;
    left: 30px;
  }
  @media (min-width: 1200px) {
    height: 80px;
  }
  img {
    height: 100%;
  }
`;

function HeaderLogo({ builder }) {
  return (
    <Link className={styles} name="index">
      <img src="/images/logo-fullColorRev.svg" alt={get(builder, 'name')} />
    </Link>
  );
}

HeaderLogo.propTypes = {
  builder: PropTypes.object.isRequired,
};

export default withData(
  {
    builder: true,
  },
)(HeaderLogo);



// WEBPACK FOOTER //
// ./src/components/Header/HeaderLogo.js